export default __webpack_public_path__ + "static/media/Resume.101a922e.pdf";